<template>
  <div class="basicPortContent">
    <Breadcrumb :matched="$route.matched" />
    <el-tabs v-model="activeName">
      <el-tab-pane label="AIS订阅记录" name="AisEventSubscription">
        <AisEvent ref="AisEventSubscription" />
      </el-tab-pane>
      <el-tab-pane label="当前挂靠" name="CurrentVoyage">
        <CurrentVoyage ref="CurrentVoyage" />
      </el-tab-pane>
      <el-tab-pane label="未匹配AIS港口" name="MismatchAisPort">
        <MismatchAisPort ref="MismatchAisPort" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue'
import BaseQuery from '@/components/BaseQuery.vue'
import AisEvent from './AisEvent.vue'
import CurrentVoyage from './CurrentVoyage.vue'
import MismatchAisPort from './MismatchAisPort.vue'

export default {
  components: {
    Breadcrumb,
    BaseQuery,
    AisEvent,
    CurrentVoyage,
    MismatchAisPort,
  },

  data() {
    return {
      activeName: 'AisEventSubscription',
    }
  },

  watch: {
    activeName() {
      this.$nextTick(this.switchtab)
    },
  },

  methods: {
    switchtab() {
      const refs = this.$refs
      Object.keys(refs).forEach(k => {
        if (k === this.activeName) {
          this.$refs[k].$emit('activate')
        } else {
          this.$refs[k].$emit('deactivate')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.basicPortContent {
  padding: 20px 20px 0 20px;

  .el-tabs {
    background-color: #fff;
    padding: 10px 0 20px 0;
  }

  ::v-deep .el-tabs__item.is-active {
    color: #333;
    font-weight: bold;
  }

  ::v-deep .el-tabs__item:hover {
    color: #333;
  }

  ::v-deep .el-tabs__item {
    font-size: 13px;
  }

  ::v-deep .el-tabs__nav-scroll {
    padding-left: 20px;
  }
}
</style>
